import * as React from "react";
import Icon from "../../types/Icon.interface";

const IconCheckboxArrow: React.FC<Icon> = (props: Icon) => {
  const { color = "#002D5A", className, style } = props;

  return (
    <svg
      width={23}
      height={17}
      viewBox="0 0 23 17"
      className={className}
      style={style}
    >
      <path
        d="M1 9.733L7.702 14.6 21 1"
        stroke={color}
        strokeWidth={3}
        fill="none"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default IconCheckboxArrow;
